module.exports = __webpack_public_path__ + "img/378.36c802b5.jpg";